/**
 * True for intentional cancellations or service-unavailability conditions
 * already surfaced to the user (ServiceStatusBanner) that must NOT be treated
 * as crashes.
 */
export function isBenignError(reason: unknown): boolean {
  if (reason instanceof DOMException && reason.name === 'AbortError') return true

  const r = reason as Record<string, unknown> | null | undefined
  if (!r) return false

  const status = r.status ?? (r.response as Record<string, unknown> | undefined)?.status
  if (status === 503) return true

  const bodyError = (r.body as Record<string, unknown> | undefined)?.error
  const topError = r.error
  if (bodyError === 'external_service_unavailable' || topError === 'external_service_unavailable') {
    return true
  }

  return false
}
